module.exports = __webpack_public_path__ + "img/SMT_23_Mr_Mohamed_Farouk_Bin_Mohamed_Ismail.487f75ba.jpg";